import { render, staticRenderFns } from "./TermsCondition.vue?vue&type=template&id=795d610c&scoped=true"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsCondition.vue?vue&type=style&index=0&id=795d610c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d610c",
  null
  
)

export default component.exports